import _IPostProcessingEffectDefinitions from "./interfaces/IPostProcessingEffectDefinitions";
import * as _postprocessing2 from "postprocessing";
var _postprocessing = _postprocessing2;
try {
  if ("default" in _postprocessing2) _postprocessing = _postprocessing2.default;
} catch (e) {}
import _EnvironmentMapLoader from "./loaders/EnvironmentMapLoader";
import * as _viewerShared2 from "@shapediver/viewer.shared.global-access-objects";
var _viewerShared = _viewerShared2;
try {
  if ("default" in _viewerShared2) _viewerShared = _viewerShared2.default;
} catch (e) {}
import _MultiPointsMaterial from "./materials/MultiPointsMaterial";
import _PostProcessingManager from "./managers/PostProcessingManager";
import _RenderingEngine from "./RenderingEngine";
import _Tag3dGeometryCreationInjector from "./injectors/Tag3dGeometryCreationInjector";
import _TextureUnifierInjector from "./injectors/TextureUnifierInjector";
import _ThreejsData from "./types/ThreejsData";
var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Resolution = exports.PredicationMode = exports.EdgeDetectionMode = exports.SMAAPreset = exports.KernelSize = exports.VignetteTechnique = exports.BlendFunction = exports.VignetteEffect = exports.TiltShiftEffect = exports.SepiaEffect = exports.SelectiveBloomEffect = exports.ScanlineEffect = exports.SSAOEffect = exports.SMAAEffect = exports.PixelationEffect = exports.OutlineEffect = exports.NoiseEffect = exports.HueSaturationEffect = exports.GridEffect = exports.GodRaysEffect = exports.FXAAEffect = exports.DotScreenEffect = exports.DepthOfFieldEffect = exports.ChromaticAberrationEffect = exports.BloomEffect = exports.EffectComposer = exports.Effect = exports.POST_PROCESSING_EFFECT_TYPE = exports.ANTI_ALIASING_TECHNIQUE = exports.PostProcessingManager = exports.MultiPointsMaterial = exports.ENVIRONMENT_MAP_EMPTY = exports.ENVIRONMENT_MAP_CUBE = exports.ENVIRONMENT_MAP = exports.ThreejsData = exports.RenderingEngine = void 0;
const IPostProcessingEffectDefinitions_1 = _IPostProcessingEffectDefinitions;
Object.defineProperty(exports, "ANTI_ALIASING_TECHNIQUE", {
  enumerable: true,
  get: function () {
    return IPostProcessingEffectDefinitions_1.ANTI_ALIASING_TECHNIQUE;
  }
});
Object.defineProperty(exports, "POST_PROCESSING_EFFECT_TYPE", {
  enumerable: true,
  get: function () {
    return IPostProcessingEffectDefinitions_1.POST_PROCESSING_EFFECT_TYPE;
  }
});
const postprocessing_1 = _postprocessing;
Object.defineProperty(exports, "BlendFunction", {
  enumerable: true,
  get: function () {
    return postprocessing_1.BlendFunction;
  }
});
Object.defineProperty(exports, "BloomEffect", {
  enumerable: true,
  get: function () {
    return postprocessing_1.BloomEffect;
  }
});
Object.defineProperty(exports, "ChromaticAberrationEffect", {
  enumerable: true,
  get: function () {
    return postprocessing_1.ChromaticAberrationEffect;
  }
});
Object.defineProperty(exports, "DepthOfFieldEffect", {
  enumerable: true,
  get: function () {
    return postprocessing_1.DepthOfFieldEffect;
  }
});
Object.defineProperty(exports, "DotScreenEffect", {
  enumerable: true,
  get: function () {
    return postprocessing_1.DotScreenEffect;
  }
});
Object.defineProperty(exports, "EdgeDetectionMode", {
  enumerable: true,
  get: function () {
    return postprocessing_1.EdgeDetectionMode;
  }
});
Object.defineProperty(exports, "Effect", {
  enumerable: true,
  get: function () {
    return postprocessing_1.Effect;
  }
});
Object.defineProperty(exports, "EffectComposer", {
  enumerable: true,
  get: function () {
    return postprocessing_1.EffectComposer;
  }
});
Object.defineProperty(exports, "FXAAEffect", {
  enumerable: true,
  get: function () {
    return postprocessing_1.FXAAEffect;
  }
});
Object.defineProperty(exports, "GodRaysEffect", {
  enumerable: true,
  get: function () {
    return postprocessing_1.GodRaysEffect;
  }
});
Object.defineProperty(exports, "GridEffect", {
  enumerable: true,
  get: function () {
    return postprocessing_1.GridEffect;
  }
});
Object.defineProperty(exports, "HueSaturationEffect", {
  enumerable: true,
  get: function () {
    return postprocessing_1.HueSaturationEffect;
  }
});
Object.defineProperty(exports, "KernelSize", {
  enumerable: true,
  get: function () {
    return postprocessing_1.KernelSize;
  }
});
Object.defineProperty(exports, "NoiseEffect", {
  enumerable: true,
  get: function () {
    return postprocessing_1.NoiseEffect;
  }
});
Object.defineProperty(exports, "OutlineEffect", {
  enumerable: true,
  get: function () {
    return postprocessing_1.OutlineEffect;
  }
});
Object.defineProperty(exports, "PixelationEffect", {
  enumerable: true,
  get: function () {
    return postprocessing_1.PixelationEffect;
  }
});
Object.defineProperty(exports, "PredicationMode", {
  enumerable: true,
  get: function () {
    return postprocessing_1.PredicationMode;
  }
});
Object.defineProperty(exports, "Resolution", {
  enumerable: true,
  get: function () {
    return postprocessing_1.Resolution;
  }
});
Object.defineProperty(exports, "ScanlineEffect", {
  enumerable: true,
  get: function () {
    return postprocessing_1.ScanlineEffect;
  }
});
Object.defineProperty(exports, "SelectiveBloomEffect", {
  enumerable: true,
  get: function () {
    return postprocessing_1.SelectiveBloomEffect;
  }
});
Object.defineProperty(exports, "SepiaEffect", {
  enumerable: true,
  get: function () {
    return postprocessing_1.SepiaEffect;
  }
});
Object.defineProperty(exports, "SMAAEffect", {
  enumerable: true,
  get: function () {
    return postprocessing_1.SMAAEffect;
  }
});
Object.defineProperty(exports, "SMAAPreset", {
  enumerable: true,
  get: function () {
    return postprocessing_1.SMAAPreset;
  }
});
Object.defineProperty(exports, "SSAOEffect", {
  enumerable: true,
  get: function () {
    return postprocessing_1.SSAOEffect;
  }
});
Object.defineProperty(exports, "TiltShiftEffect", {
  enumerable: true,
  get: function () {
    return postprocessing_1.TiltShiftEffect;
  }
});
Object.defineProperty(exports, "VignetteEffect", {
  enumerable: true,
  get: function () {
    return postprocessing_1.VignetteEffect;
  }
});
Object.defineProperty(exports, "VignetteTechnique", {
  enumerable: true,
  get: function () {
    return postprocessing_1.VignetteTechnique;
  }
});
const EnvironmentMapLoader_1 = _EnvironmentMapLoader;
Object.defineProperty(exports, "ENVIRONMENT_MAP", {
  enumerable: true,
  get: function () {
    return EnvironmentMapLoader_1.ENVIRONMENT_MAP;
  }
});
Object.defineProperty(exports, "ENVIRONMENT_MAP_CUBE", {
  enumerable: true,
  get: function () {
    return EnvironmentMapLoader_1.ENVIRONMENT_MAP_CUBE;
  }
});
Object.defineProperty(exports, "ENVIRONMENT_MAP_EMPTY", {
  enumerable: true,
  get: function () {
    return EnvironmentMapLoader_1.ENVIRONMENT_MAP_EMPTY;
  }
});
const viewer_shared_global_access_objects_1 = _viewerShared;
const MultiPointsMaterial_1 = _MultiPointsMaterial;
Object.defineProperty(exports, "MultiPointsMaterial", {
  enumerable: true,
  get: function () {
    return MultiPointsMaterial_1.MultiPointsMaterial;
  }
});
const PostProcessingManager_1 = _PostProcessingManager;
Object.defineProperty(exports, "PostProcessingManager", {
  enumerable: true,
  get: function () {
    return PostProcessingManager_1.PostProcessingManager;
  }
});
const RenderingEngine_1 = _RenderingEngine;
Object.defineProperty(exports, "RenderingEngine", {
  enumerable: true,
  get: function () {
    return RenderingEngine_1.RenderingEngine;
  }
});
const Tag3dGeometryCreationInjector_1 = _Tag3dGeometryCreationInjector;
const TextureUnifierInjector_1 = _TextureUnifierInjector;
const ThreejsData_1 = _ThreejsData;
Object.defineProperty(exports, "ThreejsData", {
  enumerable: true,
  get: function () {
    return ThreejsData_1.ThreejsData;
  }
});
const tag3dGeometryCreationInjector = new Tag3dGeometryCreationInjector_1.Tag3dGeometryCreationInjector();
viewer_shared_global_access_objects_1.GlobalAccessObjects.instance.loadTag3D = tag3dGeometryCreationInjector.convertTag3dToGeometry.bind(tag3dGeometryCreationInjector);
const textureUnifierInjector = new TextureUnifierInjector_1.TextureUnifierInjector();
viewer_shared_global_access_objects_1.GlobalAccessObjects.instance.combineTextures = textureUnifierInjector.combineTextures.bind(textureUnifierInjector);
//# sourceMappingURL=index.js.map
export default exports;
export const __esModule = exports.__esModule,
  Resolution = exports.Resolution,
  PredicationMode = exports.PredicationMode,
  EdgeDetectionMode = exports.EdgeDetectionMode,
  SMAAPreset = exports.SMAAPreset,
  KernelSize = exports.KernelSize,
  VignetteTechnique = exports.VignetteTechnique,
  BlendFunction = exports.BlendFunction,
  VignetteEffect = exports.VignetteEffect,
  TiltShiftEffect = exports.TiltShiftEffect,
  SepiaEffect = exports.SepiaEffect,
  SelectiveBloomEffect = exports.SelectiveBloomEffect,
  ScanlineEffect = exports.ScanlineEffect,
  SSAOEffect = exports.SSAOEffect,
  SMAAEffect = exports.SMAAEffect,
  PixelationEffect = exports.PixelationEffect,
  OutlineEffect = exports.OutlineEffect,
  NoiseEffect = exports.NoiseEffect,
  HueSaturationEffect = exports.HueSaturationEffect,
  GridEffect = exports.GridEffect,
  GodRaysEffect = exports.GodRaysEffect,
  FXAAEffect = exports.FXAAEffect,
  DotScreenEffect = exports.DotScreenEffect,
  DepthOfFieldEffect = exports.DepthOfFieldEffect,
  ChromaticAberrationEffect = exports.ChromaticAberrationEffect,
  BloomEffect = exports.BloomEffect,
  EffectComposer = exports.EffectComposer,
  Effect = exports.Effect,
  POST_PROCESSING_EFFECT_TYPE = exports.POST_PROCESSING_EFFECT_TYPE,
  ANTI_ALIASING_TECHNIQUE = exports.ANTI_ALIASING_TECHNIQUE,
  PostProcessingManager = exports.PostProcessingManager,
  MultiPointsMaterial = exports.MultiPointsMaterial,
  ENVIRONMENT_MAP_EMPTY = exports.ENVIRONMENT_MAP_EMPTY,
  ENVIRONMENT_MAP_CUBE = exports.ENVIRONMENT_MAP_CUBE,
  ENVIRONMENT_MAP = exports.ENVIRONMENT_MAP,
  ThreejsData = exports.ThreejsData,
  RenderingEngine = exports.RenderingEngine;